// import { AlertModalComponent } from './../alert/alert.component';
import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, Inject, ChangeDetectorRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Store } from '@ngrx/store';
import * as fromPaymentConfig from '../../../screens/payment-config/state/payment-config.selectors';
import { Subscription, Observable } from 'rxjs';
import { AlertModalComponent } from '../alert/alert.component';
import * as moment from 'moment'
import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IPaymentOption, IPaymentProcessor, ITaxSubsection, LGEDataService } from 'src/commons';
import { ConfirmModalComponent } from '..';
// import { ConfirmModalComponent } from '../confirm/confirm.component.';
import * as appConfig from 'src/app/app.constant';


@Component({
    selector: 'payment-config-details',
    templateUrl: './payment-config-detail.component.html',
    styleUrls: ['./payment-config-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PaymentConfigDetailsComponent implements OnInit, OnDestroy {
    @Input() title: string;
    @Input() configType: string;
    // @Input() private einOrgInfo: any;
    @Input() private configData: any;
    @Input() private paymentOptionsData$: Observable<IPaymentOption[] | null>;
    private paymentOptionsDataSubscription: Subscription;
    @Input() private taxExemptSubsectionsData$: Observable<ITaxSubsection[] | null>;
    private taxExemptSubsectionsDataSubscription: Subscription;
    @Input() private paymentProcessorData$: Observable<IPaymentProcessor[] | null>;
    private paymentProcessorDataSubscription: Subscription;
    minEffdt = new Date('');

    paymentConfigForm: FormGroup;
    paymentProcessorForm: FormGroup;
    isEditMode: boolean;
    isReadOnly = false;
    paymentOptions: any;
    paymentProcessors: any;
    taxExemptSubsections: any;
    // public confirm: any;
    alert: any;
    confirm: any;
    minDate = moment();
    datePipe = new DatePipe('en-US');

    states = []
    constructor(

        private _dataService: LGEDataService,
        private dialog: MatDialog,
        private dialogRef: MatDialogRef<PaymentConfigDetailsComponent>,
        private ref: ChangeDetectorRef,
        private store: Store<fromPaymentConfig.State>,
        private fb: FormBuilder, @Inject(MAT_DIALOG_DATA) private data: any) {
        this.configType = data.configType;
        this.title = data.title;
        // this.einOrgInfo = data.einOrgInfo;
        this.configData = data.configData;
        this.isEditMode = data.isEditMode;
        this.selectState();
    }

    private selectState(): void {
        this.states = appConfig.SHARE_ARRAYS.states;
        this.paymentOptionsData$ = this.store.select(fromPaymentConfig.getPaymentOptionState);
        this.taxExemptSubsectionsData$ = this.store.select(fromPaymentConfig.getSubsectionsState);
        this.paymentProcessorData$ = this.store.select(fromPaymentConfig.getPaymentProcessorState);
    }

    private startSubscriptions(): void {
        this.paymentOptionsDataSubscription = this.paymentOptionsData$
            .subscribe(data => {
                if (data != null) {
                    this.paymentOptions = data;
                    this.ref.markForCheck();
                }
            });

        this.taxExemptSubsectionsDataSubscription = this.taxExemptSubsectionsData$
            .subscribe(data => {
                if (data != null) {
                    this.taxExemptSubsections = data.filter(s => s.isActive);
                    this.ref.markForCheck();
                }
            })
        this.paymentProcessorDataSubscription = this.paymentProcessorData$
            .subscribe(data => {
                if (data != null) {
                    this.paymentProcessors = data;
                    this.ref.markForCheck();
                }
            })
    }
    // Unsubscribe from state data changes
    private endSubscriptions(): void {
        this.paymentOptionsDataSubscription.unsubscribe();
        this.taxExemptSubsectionsDataSubscription.unsubscribe();
        this.paymentProcessorDataSubscription.unsubscribe();
    }

    ngOnDestroy() {
        this.endSubscriptions();
    }


    ngOnInit() {
        this.startSubscriptions();
        this.createForms();
    }

    private createForms(): void {
        if (this.configType === 'form') {
            this.paymentConfigForm = this.fb.group({
                'ID': [-1, Validators.required],
                'formType': ['', Validators.required],
                'subsection': ['03', Validators.required],
                'paymentProcessor': ['', Validators.required],
                'paymentOptions': [{ value: [], disabled: true }, Validators.required],
                'startDate': ['', [Validators.required]],
                'endDate': ['', [Validators.required]],
                'deleteIt': [0]
            })
            this.paymentConfigForm.setValue(this.configData);
            this.paymentConfigForm.get('startDate').valueChanges.subscribe((newVal) => {
                // const current = this.formConfig.value.startDate;
                const endDate = this.paymentConfigForm.value.endDate;
                if (newVal !== null && endDate !== null) {
                    if (moment(newVal) > moment(endDate)) {
                        this.showAlert('Time Range Invalid', 'Please select valid start date!');
                        this.paymentConfigForm.get('startDate').setValue(moment(endDate).startOf('day'));
                    }
                }
            });

            this.paymentConfigForm.get('endDate').valueChanges.subscribe((newVal) => {
                // const current = this.formConfig.value.startDate;
                const startDate = this.paymentConfigForm.value.startDate;
                if (newVal !== null && startDate !== null) {
                    if (moment(startDate) > moment(newVal)) {
                        this.showAlert('Time Range Invalid', 'Please select valid end date!');
                        this.paymentConfigForm.get('endDate').setValue(moment(startDate).endOf('day').subtract(1, 'seconds'));
                    }
                }
            });
            this.paymentConfigForm.get('startDate').setValue(new Date(this.configData.startDate));
            this.paymentConfigForm.get('endDate').setValue(new Date(this.configData.endDate));
        } else {
            this.paymentProcessorForm = this.fb.group({
                'paymentProcessor': ['', Validators.required],
                'paymentOptions': [[], Validators.required],
            })
            this.paymentProcessorForm.setValue(this.configData);
        }

    }

    getTaxExemptStatus(value) {
        if (value === '')
            return 'Other';
        else if (isNaN(value) || +value === 0) {
            return value;
        } else {
            return `501(c)(${+value})`;
        }
    }

    // public showConfirm(title: string, message: string) {
    //     this.confirm = this.dialog.open(ConfirmModalComponent, {
    //         width: '350px',
    //         disableClose: false,
    //         data: { title: title, message: message }
    //     });
    // }

    // public showAlert(title: string, message: string) {
    //     this.alert = this.dialog.open(AlertModalComponent, {
    //         width: '260px',
    //         disableClose: true,
    //         data: { title: title, message: message }
    //     });
    // }

    onSave() {
        // let isDuplicate = this.einOrgDetail.filter(e => e.ein === this.einOrgForm.value.ein).length > 0;
        // if (isDuplicate) {
        //     this.showAlert('Alert!', 'EIN:  "' + this.einOrgForm.value.ein + '"  is already exist!');
        // } else {
        this.showConfirm('Are you sure you want to save?', '');
        this.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                if (this.configType === 'form') {
                    const startDate = this.paymentConfigForm.get('startDate').value;
                    const endDate = this.paymentConfigForm.get('endDate').value;
                    this.paymentConfigForm.get('startDate').setValue(this.datePipe.transform(startDate, 'MM-dd-yyyy').toString());
                    this.paymentConfigForm.get('endDate').setValue(this.datePipe.transform(endDate, 'MM-dd-yyyy').toString());
                    this.dialogRef.close(this.paymentConfigForm.value);
                } else {
                    this.dialogRef.close(this.paymentProcessorForm.value);
                }
            }
        });
        // }
    }

    public showConfirm(title: string, message: string) {
        this.confirm = this.dialog.open(ConfirmModalComponent, {
            width: '350px',
            disableClose: false,
            data: { title: title, message: message }
        });
    }
    public showAlert(title: string, message: string) {
        this.confirm = this.dialog.open(AlertModalComponent, {
            width: '250px',
            disableClose: true,
            data: { title: title, message: message }
        });
    }
    onChangeProcessor(value) {
        const po = this.paymentProcessors.find(pp => pp.paymentProcessor === value);
        this.paymentConfigForm.get('paymentOptions').setValue(po.paymentOptions);
    }

    onCancel() {
        this.showConfirm('Are you sure you want to cancel?', '');
        this.confirm.afterClosed().subscribe(result => {
            if (result === 'yes') {
                this.dialogRef.close();
            }
        });
    }

}
